/* eslint-disable formatjs/no-literal-string-in-jsx */
import { csx, cx, Tooltip } from '@vtex/admin-ui'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import TruncateMarkup from 'react-truncate-markup'
import type { DefaultProps } from 'typings'
import { Tag } from '.'
import styles from './styles.css'

interface StyledComponent extends DefaultProps {
  className?: string
}

export function TagsListTruncate(
  props: StyledComponent & {
    content: string[]
    maxWidth?: number | string
    lines?: number
    showEllipsis?: boolean
  }
) {
  const {
    className = '',
    children,
    content,
    maxWidth,
    lines,
    showEllipsis = true,
  } = props
  const { formatNumber, formatList } = useIntl()

  const readMoreElipsis = useCallback(
    (node: any) => {
      const renderedLength = node.props.children.length
      const allItemsLength = content.length
      return (
        <Tooltip
          text={formatList(content.slice(renderedLength, allItemsLength))}
        >
          <Tag>+ {formatNumber(allItemsLength - renderedLength)}</Tag>
        </Tooltip>
      )
    },
    [content, formatNumber, formatList]
  )

  return (
    <TruncateMarkup
      lines={lines ?? 1}
      {...(showEllipsis ? { ellipsis: readMoreElipsis } : { ellipsis: '' })}
    >
      <div
        className={cx(
          className,
          csx({ width: maxWidth }),
          styles.tagsListTruncate
        )}
        role="list"
      >
        {children}
      </div>
    </TruncateMarkup>
  )
}

TagsListTruncate.Atom = TruncateMarkup.Atom
